export const APP_ENV = import.meta.env.VITE_APP_ENV;

export const log = (message?: any, ...optionalParams: any[]) => {
	APP_ENV !== "prod" && console.log(message, ...optionalParams);
};

export const logError = (message?: any, ...optionalParams: any[]) => {
	APP_ENV !== "prod" && console.error(message, ...optionalParams);
};
